import React, { createContext, useContext, useState } from 'react';
import { completeTour } from './tourStorage';

export type TourType = 'recruiter' | 'talent' | null;

type TourContextType = {
    running: boolean;
    activeTour: TourType;
    stepIndex: number;
    start: (tour: TourType) => void;
    finish: () => void;
    setStepIndex: (index: number) => void;
};

const TourContext = createContext<TourContextType>({
    running: false,
    activeTour: null,
    stepIndex: 0,
    start: () => { },
    finish: () => { },
    setStepIndex: () => { },
});

export const TourGuideProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [running, setRunning] = useState(false);
    const [activeTour, setActiveTour] = useState<TourType>(null);
    const [stepIndex, setStepIndex] = useState(0);

    const start = (tour: TourType) => {
        setActiveTour(tour);
        setRunning(true);
        setStepIndex(0); // Reset to first step when starting
    };

    const finish = () => {
        setRunning(false);
        setActiveTour(null);
        setStepIndex(0);
        completeTour(activeTour);
    };

    return (
        <TourContext.Provider value={{ running, activeTour, stepIndex, start, finish, setStepIndex }}>
            {children}
        </TourContext.Provider>
    );
};

export const useTour = () => useContext(TourContext);